<atom-app-update-banner />

<main class="h-dvh w-full overflow-hidden overscroll-none">

  @if ((firebaseService.user$ | async) && currentUserService.onboardingComplete() &&
  !isPublicReportPath()) {
  <div
    class="relative isolate flex h-full w-full flex-col overflow-hidden"
    [class]="isShoutPlusShell() ? 'bg-black' : 'bg-zinc-100 dark:bg-zinc-950'">
    <header class="relative flex items-center px-4 shrink-0" [class]="headerClass()">
      <div class="flex h-16 w-full items-center justify-between gap-3 lg:hidden">
        <a (click)="goToDashboard()" class="relative inline-flex cursor-pointer rounded-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          aria-label="Go to dashboard">
          @if (usesDarkAppHeader()) {
          <img src="https://shout-ugc-assets.s3.eu-west-1.amazonaws.com/shout-main/SHOUT_logo_white.svg" class="h-4" alt="SHOUT">
          } @else {
          <img src="https://shout-ugc-assets.s3.eu-west-1.amazonaws.com/shout-main/SHOUT_logo_black.svg" class="h-4 dark:hidden" alt="SHOUT">
          <img src="https://shout-ugc-assets.s3.eu-west-1.amazonaws.com/shout-main/SHOUT_logo_white.svg" class="hidden h-4 dark:block" alt="SHOUT">
          }
        </a>
        <button type="button" (click)="toggleMobileNav()" class="rounded-lg p-2 focus-visible:outline-2 focus-visible:outline-offset-2" [class]="usesDarkAppHeader() ? 'text-white hover:bg-white/10 focus-visible:outline-white' : 'text-zinc-700 hover:bg-zinc-950/5 focus-visible:outline-primary dark:text-zinc-200 dark:hover:bg-white/10'"
          [attr.aria-expanded]="mobileNavOpen()" aria-controls="mobile-nav-panel"
          [attr.aria-label]="mobileNavOpen() ? 'Close menu' : 'Open menu'">
          @if (mobileNavOpen()) {
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-7" aria-hidden="true">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
          } @else {
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-7" aria-hidden="true">
            <path d="M4 5h16" />
            <path d="M4 12h16" />
            <path d="M4 19h16" />
          </svg>
          }
        </button>
      </div>

      <div class="hidden min-w-0 flex-1 lg:flex">


        <nav class="flex flex-1 items-center gap-4">
          <a (click)="goToDashboard()"
            class="max-lg:hidden relative inline-flex cursor-pointer rounded-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
            aria-label="Go to dashboard">
            <div class="w-full flex justify-center items-center">
              @if (usesDarkAppHeader()) {
          <img src="https://shout-ugc-assets.s3.eu-west-1.amazonaws.com/shout-main/SHOUT_logo_white.svg" class="h-4" alt="SHOUT">
          } @else {
          <img src="https://shout-ugc-assets.s3.eu-west-1.amazonaws.com/shout-main/SHOUT_logo_black.svg" class="h-4 dark:hidden" alt="SHOUT">
          <img src="https://shout-ugc-assets.s3.eu-west-1.amazonaws.com/shout-main/SHOUT_logo_white.svg" class="hidden h-4 dark:block" alt="SHOUT">
          }
            </div>
          </a>

          <div aria-hidden="true" class="h-8 w-px" [class]="usesDarkAppHeader() ? 'bg-white/20' : 'bg-zinc-950/10 dark:bg-white/10'"></div>

          <div role="group" aria-label="Choose area" class="inline-flex shrink-0 items-center rounded-full p-1" [class]="usesDarkAppHeader() ? 'bg-white/10' : 'bg-zinc-950/5 dark:bg-white/10'">
            <button type="button" (click)="chooseArea('studio')"
              [attr.aria-pressed]="displayedArea() === 'studio'"
              [class]="studioSwitcherClass()">
              Studio
            </button>
            <button type="button" (click)="chooseArea('shout-plus')"
              [attr.aria-pressed]="displayedArea() === 'shout-plus'"
              [class]="shoutPlusSwitcherClass()">
              SHOUT+
            </button>
          </div>
          <p class="m-0 whitespace-nowrap text-sm" [class]="usesDarkAppHeader() ? 'text-white/80' : 'text-zinc-600 dark:text-zinc-400'">{{ areaTagline() }}</p>
          <div class="min-w-0 flex-1"></div>

          <div class="flex flex-0 flex-row space-x-2 sm:space-x-4 items-center">

            @if (showFullNavigation()) {
            @if (currentUserService.currentSubscription() && currentUserService.currentSubscription()!.status ==
            'trialing') {
            <span routerLink="/my-brand/billing"
              class="inline-flex shrink-0 whitespace-nowrap items-center rounded-full px-2 py-1 text-xs font-medium inset-ring hover:cursor-pointer" [class]="usesDarkAppHeader() ? 'bg-primary/30 text-white inset-ring-white/40' : 'bg-primary/10 text-primary inset-ring-primary/30'">{{
              currentUserService.trialCountdownDaysLabelShort() }}</span>
            }

            <!-- Insights Button -->
            <button *appHasRole="[6]" type="button" (click)="goToANonTab('/insights')"
              class="relative rounded-full p-1 hover:text-primary focus:outline-2 focus:outline-offset-2 focus:outline-primary hover:cursor-pointer"
              [class]="getInsightsSelectedClass()">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5 sm:size-6" [class]="getInsightsSelectedIconClass()">
                <path d="M14 18a2 2 0 0 0-4 0" />
                <path
                  d="m19 11-2.11-6.657a2 2 0 0 0-2.752-1.148l-1.276.61A2 2 0 0 1 12 4H8.5a2 2 0 0 0-1.925 1.456L5 11" />
                <path d="M2 11h20" />
                <circle cx="17" cy="18" r="3" />
                <circle cx="7" cy="18" r="3" />
              </svg>
            </button>
            <!-- Insights Button - END -->

            <!-- Admin Options Button -->
            <button *appHasRole="[6]" type="button" (click)="goToANonTab('/admin-options')"
              class="relative rounded-full p-1 hover:text-primary focus:outline-2 focus:outline-offset-2 focus:outline-primary hover:cursor-pointer"
              [class]="getAdminOptionsSelectedClass()">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5 sm:size-6" [class]="getAdminOptionsSelectedIconClass()">
                <path
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                <path d="M8 12h.01" />
                <path d="M12 12h.01" />
                <path d="M16 12h.01" />
              </svg>
            </button>
            <!-- Admin Options Button - END -->

            <!-- Support Button -->
            <button type="button" (click)="goToANonTab('/support')"
              class="relative inline-flex items-center gap-1 rounded-full p-1 focus:outline-2 focus:outline-offset-2 focus:outline-primary hover:cursor-pointer"
              [class]="navIconClass()"
              [attr.aria-label]="
                supportService.unreadUserTicketCount() > 0
                  ? 'Support. ' + supportService.unreadUserTicketCount() + ' unread replies.'
                  : 'Support'
              ">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5 sm:size-6" aria-hidden="true">
                <circle cx="12" cy="12" r="10" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                <path d="M12 17h.01" />
              </svg>
              @if (supportService.unreadUserTicketCount() > 0) {
                <span
                  class="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-indigo-600 px-1.5 text-xs font-semibold text-white"
                  [attr.aria-label]="supportService.unreadUserTicketCount() + ' unread support replies'">
                  {{ supportService.unreadUserTicketCount() }}
                </span>
              }
            </button>
            <!-- Support Button - END -->

            <!-- Support Tickets (GodMode / Shout Agency User) -->
            <button *appHasRole="[2, 9]" type="button" (click)="goToANonTab('/support-admin')"
              class="relative inline-flex items-center gap-1 rounded-full p-1 focus:outline-2 focus:outline-offset-2 focus:outline-primary hover:cursor-pointer"
              [class]="navIconClass()"
              [attr.aria-label]="
                'Support tickets. ' +
                supportService.assignedOpenTicketCount() +
                ' assigned to me. ' +
                supportService.openTicketCount() +
                ' open total.'
              ">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5 sm:size-6" aria-hidden="true">
                <path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3" />
              </svg>
              <span class="inline-flex items-center gap-1">
                @if (supportService.assignedOpenTicketCount() > 0) {
                  <span
                    class="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-indigo-600 px-1.5 text-xs font-semibold text-white"
                    [attr.aria-label]="supportService.assignedOpenTicketCount() + ' tickets assigned to me'">
                    {{ supportService.assignedOpenTicketCount() }}
                  </span>
                }
                @if (supportService.openTicketCount() > 0) {
                  <span
                    class="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-gray-200 px-1.5 text-xs font-semibold text-gray-700 dark:bg-zinc-600 dark:text-zinc-100"
                    [attr.aria-label]="supportService.openTicketCount() + ' open tickets'">
                    {{ supportService.openTicketCount() }}
                  </span>
                }
              </span>
            </button>
            <!-- Support Tickets (GodMode / Shout Agency User) - END -->

            <!-- God Mode Options Button -->
            <button *appHasRole="[2]" type="button" (click)="goToANonTab('/god-mode-options')"
              class="relative rounded-full p-1 hover:text-primary focus:outline-2 focus:outline-offset-2 focus:outline-primary hover:cursor-pointer"
              [class]="getGotModeOptionsSelectedClass()">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5 sm:size-6">
                <path d="M16 3v2.107" />
                <path
                  d="M17 9c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 22 17a5 5 0 0 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C13 11.5 16 9 17 9" />
                <path d="M21 8.274V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.938" />
                <path d="M3 15h5.253" />
                <path d="M3 9h8.228" />
                <path d="M8 15v6" />
                <path d="M8 3v6" />
              </svg>

            </button>
            <!-- God Mode Options Button - END -->





            @if (getStreamService.totalUnreadCount() > 0) {
            <button type="button" (click)="goToANonTab('/inbox')"
              class="inline-flex items-center gap-x-2.5 rounded-full bg-red-600 px-2.5 py-1.5 text-md font-semibold text-white shadow-xs hover:bg-red-500 focus-visible:outline-2 focus:outline-offset-2 focus:outline-red-600">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="-ml-0.5 size-5 sm:size-6">
                <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
                <path
                  d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
              </svg>

              {{ getStreamService.totalUnreadCount() }}
            </button>
            } @else {
            <button type="button" (click)="goToANonTab('/inbox')"
              class="relative rounded-full p-1 focus:outline-2 focus:outline-offset-2 focus:outline-primary hover:cursor-pointer"
              [class]="navIconClass(getInboxSelectedClass())">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5 sm:size-6">
                <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
                <path
                  d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
              </svg>
            </button>
            }

            <atom-notifications-drawer></atom-notifications-drawer>

            @if (canAccessSandboxBilling) {
            <div class="inline-flex rounded-md">
              <button type="button" (click)="goToANonTab('/wallet-v2')"
                data-guide-id="wallet.balanceButton"
                class="hidden relative sm:inline-flex shrink-0 items-center whitespace-nowrap rounded-l-md bg-primary dark:bg-primary px-3 py-2 text-sm font-semibold text-white inset-ring-1 inset-ring-zinc-300 dark:inset-ring-white/10 hover:bg-primary/90 dark:hover:bg-primary/90 focus:z-10 focus:outline-hidden cursor-pointer">
                {{ walletService.availableBalance() | currency:walletService.currencyCode()?.toUpperCase() }}
                <span class="sr-only">View wallet transactions</span></button>
              <el-dropdown [open]="walletButtonOpen()" class="relative -ml-px block">



                <!-- Desktop Wallet Button -->
                <!-- @if (!isDesktop()) { -->
                <button command="show-modal" commandfor="walletDropDownMenu" type="button"
                  (click)="walletButtonOpen.set(!walletButtonOpen())"
                  class="relative sm:inline-flex items-center rounded-r-md bg-primary dark:bg-primary px-2 py-2 text-white inset-ring-1 inset-ring-zinc-300 dark:inset-ring-white/10 hover:bg-primary/90 dark:hover:bg-primary/90 focus:z-10 cursor-pointer">
                  <span class="sr-only">Open options</span>
                  <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5">
                    <path
                      d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                      clip-rule="evenodd" fill-rule="evenodd" />
                  </svg>
                </button>
                <!-- } -->
                <!-- } @else { -->
                <!-- Mobile Wallet Button -->
                <!-- <button command="show-modal" commandfor="walletDropDownMenu" type="button"
                  (click)="walletButtonOpen.set(!walletButtonOpen())"
                  class="md:hidden relative rounded-full p-1 text-gray-400 hover:text-white focus:outline-2 focus:outline-offset-2 focus:outline-primary hover:cursor-pointer"
                  [class]="getInboxSelectedClass()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 sm:size-6">
                    <path d="M17 14h.01" />
                    <path d="M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14" />
                  </svg>
                </button> -->
                <!-- } -->



                <el-menu anchor="bottom end" id="walletDropDownMenu" popover [open]="walletButtonOpen()"
                  class="ml-1 w-56 origin-top-right rounded-md dark:bg-gray-800 bg-gray-100 outline-1 -outline-offset-1 outline-white/10 transition transition-discrete [--anchor-gap:--spacing(2)] data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in shadow-md">
                  <div class="py-1">
                    <a (click)="openTopUpDrawer()" data-guide-id="wallet.addFunds"
                      class="w-full px-4 py-2 text-sm text-primary focus:bg-white/5 focus:text-primary focus:outline-hidden cursor-pointer inline-flex items-center gap-x-1.5 dark:hover:bg-primary/90 hover:bg-primary hover:!text-white dark:hover:!text-white">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-4">
                        <path d="M12 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5" />
                        <path d="M18 12h.01" />
                        <path d="M19 22v-6" />
                        <path d="m22 19-3-3-3 3" />
                        <path d="M6 12h.01" />
                        <circle cx="12" cy="12" r="2" />
                      </svg>
                      Add Funds</a>
                    <a (click)="goToANonTab('/wallet-v2')"
                      class="w-full px-4 py-2 text-sm text-primary focus:bg-white/5 focus:text-primary focus:outline-hidden cursor-pointer inline-flex items-center gap-x-1.5 dark:hover:bg-primary/90 hover:bg-primary hover:!text-white dark:hover:!text-white">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-4">
                        <path
                          d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" />
                        <path d="M8 11h8" />
                        <path d="M8 7h6" />
                      </svg>
                      Wallet Transactions</a>
                    <!-- <a (click)="goToANonTab('/manage-tokens')"
                      class="w-full px-4 py-2 text-sm text-primary focus:bg-white/5 focus:text-primary focus:outline-hidden cursor-pointer inline-flex items-center gap-x-1.5 dark:hover:bg-primary/90 hover:bg-primary">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-4">
                        <circle cx="8" cy="8" r="6" />
                        <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
                        <path d="M7 6h1v4" />
                        <path d="m16.71 13.88.7.71-2.82 2.82" />
                      </svg>
                      Manage Tokens</a> -->

                  </div>
                </el-menu>
              </el-dropdown>
            </div>
            }

            <div
              class="group relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 inset-ring inset-ring-gray-900/5 outline-offset-2 outline-indigo-600 transition-colors duration-200 ease-in-out has-checked:bg-indigo-600 has-focus-visible:outline-2 dark:bg-white/5 dark:inset-ring-white/10 dark:outline-indigo-500 dark:has-checked:bg-indigo-500"
              [appTooltip]="themeService.isDarkMode() ? 'Switch to light mode' : 'Switch to dark mode'"
              position="bottom">
              <span
                class="size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-checked:translate-x-5">
              </span>
              <input type="checkbox" name="theme-toggle" [checked]="themeService.isDarkMode()"
                (change)="themeService.toggle()"
                class="absolute inset-0 size-full appearance-none focus:outline-hidden cursor-pointer"
                [attr.aria-label]="themeService.isDarkMode() ? 'Switch to light mode' : 'Switch to dark mode'" />
            </div>
            }

            @if (currentUserService.shoutUser$ | async; as shoutUser) {
            @if (shoutUser?.photoURL) {
            <a (click)="goToANonTab('/my-account')" class="relative inline-block size-8"
              [class]="getAccountSelectedClass()">
              <img [src]="imageService.getImageSource(shoutUser.photoURL, 'gallery')" alt=""
                class="size-8 shrink-0 rounded-full bg-gray-700 outline-1 -outline-offset-1 outline-white/10 hover:cursor-pointer"
                (error)="onImageError($event)" alt="User" />
              @if (currentUserService.isImpersonating()) {
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                class="absolute -bottom-2 -right-2 size-6 text-red-500">
                <path fill-rule="evenodd"
                  d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                  clip-rule="evenodd" />
              </svg>
              }
            </a>
            } @else {
            <a (click)="goToANonTab('/my-account')"
              class="relative inline-flex items-center justify-center rounded-full p-1 text-gray-400 hover:text-white focus:outline-2 focus:outline-offset-2 focus:outline-primary hover:cursor-pointer"
              [class]="getAccountSelectedClass()">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5 sm:size-6">
                <path d="M18 20a6 6 0 0 0-12 0" />
                <circle cx="12" cy="10" r="4" />
                <circle cx="12" cy="12" r="10" />
              </svg>
            </a>
            }
            }
          </div>
        </nav>

      </div>
    </header>

    @if (!hideAreaTabs()) {
    @if (shoutPlusLocked()) {
    <nav aria-label="SHOUT+ navigation" class="hidden items-center gap-4 border-b border-white/10 bg-black px-6 py-3 lg:flex">
      <p [class]="areaLabelClass()">SHOUT+</p>
      <div class="flex items-center gap-2 text-sm text-white/70">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4" aria-hidden="true">
          <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
        <p class="m-0">Not included in your current plan</p>
      </div>
    </nav>
    } @else {
    <nav [attr.aria-label]="displayedArea() === 'shout-plus' ? 'SHOUT+ navigation' : 'Studio navigation'"
      class="hidden items-center gap-10 px-6 lg:flex" [class]="areaTabsRowClass()">
      <p [class]="areaLabelClass()">{{ displayedArea() === 'shout-plus' ? 'SHOUT+' : 'STUDIO' }}</p>
      @for (item of (displayedArea() === 'shout-plus' ? shoutPlusTabs() : studioTabs()); track item.id) {
      <ng-container [ngTemplateOutlet]="navTab" [ngTemplateOutletContext]="{ $implicit: item, placement: 'row' }" />
      }
    </nav>
    }
    }

    <ng-template #navTab let-item let-placement="placement">
      <button type="button" [attr.data-guide-id]="'nav.' + item.id"
        class="group inline-flex cursor-pointer items-center whitespace-nowrap border-b-2 text-sm focus-visible:outline-2 focus-visible:outline-offset-2"
        [class]="tabButtonClass(item, placement)"
        [attr.aria-current]="isTabActive(item) ? 'page' : null"
        (click)="selectAreaTab(item)">
        @if (item.brandTab) {
        @if (currentUserService.focussedBrand$ | async; as focussedBrand) {
        @if (focussedBrand.companyLogo) {
        <img [src]="imageService.getImageSource(focussedBrand.companyLogo, 'gallery')" alt=""
          class="sm:-ml-0.5 sm:mr-2 size-6 rounded-full sm:size-5">
        } @else {
        <span [innerHTML]="getSafeHtml(item.icon)"></span>
        }
        <span class="hidden sm:inline">{{ focussedBrand.companyName || item.label }}</span>
        } @else {
        <span [innerHTML]="getSafeHtml(item.icon)"></span>
        <span class="hidden sm:inline">{{ item.label }}</span>
        }
        } @else {
        <span [innerHTML]="getSafeHtml(item.icon)"></span>
        <span class="hidden sm:inline">{{ item.label }}</span>
        }
      </button>
    </ng-template>

    @if (mobileNavOpen()) {
    <div class="fixed inset-0 z-50 lg:hidden" role="dialog" aria-modal="true" aria-labelledby="mobile-nav-title">
      <button type="button" class="absolute inset-0 bg-zinc-950/60" (click)="closeMobileNav()" aria-label="Close menu"></button>
      <nav id="mobile-nav-panel" class="mobile-nav-panel absolute inset-y-0 right-0 flex w-full max-w-xs flex-col overflow-y-auto border-l border-border bg-white p-4 shadow-xl dark:bg-zinc-900">
        <div class="mb-4 flex items-center justify-between">
          <h2 id="mobile-nav-title" class="text-base font-semibold text-primary">Menu</h2>
          <button type="button" (click)="closeMobileNav()" class="rounded-lg p-2 text-primary hover:bg-zinc-100 dark:hover:bg-zinc-800" aria-label="Close menu">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-6" aria-hidden="true">
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </div>

        <div class="flex flex-col gap-1">
          <div role="group" aria-label="Choose area" class="mb-2 grid grid-cols-2 gap-2">
            <button type="button" (click)="chooseArea('studio')"
              [attr.aria-pressed]="displayedArea() === 'studio'"
              class="rounded-full px-3 py-2 text-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
              [class]="displayedArea() === 'studio' ? 'bg-primary font-semibold text-primary-foreground' : 'bg-zinc-100 font-medium text-primary dark:bg-zinc-800'">
              Studio
            </button>
            <button type="button" (click)="chooseArea('shout-plus')"
              [attr.aria-pressed]="displayedArea() === 'shout-plus'"
              class="rounded-full px-3 py-2 text-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
              [class]="displayedArea() === 'shout-plus' ? 'shout-plus-gold-shadow bg-amber-400 font-semibold text-zinc-950' : 'bg-zinc-100 font-medium text-primary dark:bg-zinc-800'">
              SHOUT+
            </button>
          </div>
          <p class="m-0 mb-2 text-sm text-secondary">{{ areaTagline() }}</p>
          @if (shoutPlusLocked()) {
          <p class="m-0 px-3 py-2 text-sm text-secondary">Not included in your current plan</p>
          } @else {
          @for (item of (displayedArea() === 'shout-plus' ? shoutPlusTabs() : studioTabs()); track item.id) {
          <button type="button" (click)="selectAreaTab(item)"
            class="flex w-full items-center gap-3 rounded-lg px-3 py-3 text-left text-sm text-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
            [class]="mobileTabClass(item)"
            [attr.aria-current]="isTabActive(item) ? 'page' : null">
            <span [innerHTML]="getSafeHtml(item.icon)"></span>
            <span>{{ item.label }}</span>
          </button>
          }
          }
        </div>

        @if (showFullNavigation()) {
        <div class="my-4 border-t border-border"></div>

        <div class="flex flex-col gap-1">
          <button *appHasRole="[6]" type="button" (click)="goToANonTab('/insights')"
            class="flex items-center gap-3 rounded-lg px-3 py-3 text-left text-sm font-medium text-primary hover:bg-zinc-100 dark:hover:bg-zinc-800">
            Insights
          </button>
          <button *appHasRole="[6]" type="button" (click)="goToANonTab('/admin-options')"
            class="flex items-center gap-3 rounded-lg px-3 py-3 text-left text-sm font-medium text-primary hover:bg-zinc-100 dark:hover:bg-zinc-800">
            Admin
          </button>
          <button type="button" (click)="goToANonTab('/support')"
            class="flex items-center justify-between rounded-lg px-3 py-3 text-left text-sm font-medium text-primary hover:bg-zinc-100 dark:hover:bg-zinc-800">
            <span>Support</span>
            @if (supportService.unreadUserTicketCount() > 0) {
            <span class="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-indigo-600 px-1.5 text-xs font-semibold text-white">
              {{ supportService.unreadUserTicketCount() }}
            </span>
            }
          </button>
          <button *appHasRole="[2, 9]" type="button" (click)="goToANonTab('/support-admin')"
            class="flex items-center justify-between rounded-lg px-3 py-3 text-left text-sm font-medium text-primary hover:bg-zinc-100 dark:hover:bg-zinc-800">
            <span>Support tickets</span>
            @if (supportService.openTicketCount() > 0) {
            <span class="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-gray-200 px-1.5 text-xs font-semibold text-gray-700 dark:bg-zinc-600 dark:text-zinc-100">
              {{ supportService.openTicketCount() }}
            </span>
            }
          </button>
          <button *appHasRole="[2]" type="button" (click)="goToANonTab('/god-mode-options')"
            class="flex items-center gap-3 rounded-lg px-3 py-3 text-left text-sm font-medium text-primary hover:bg-zinc-100 dark:hover:bg-zinc-800">
            God mode
          </button>
          <button type="button" (click)="goToANonTab('/inbox')"
            class="flex items-center justify-between rounded-lg px-3 py-3 text-left text-sm font-medium text-primary hover:bg-zinc-100 dark:hover:bg-zinc-800">
            <span>Inbox</span>
            @if (getStreamService.totalUnreadCount() > 0) {
            <span class="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-red-600 px-1.5 text-xs font-semibold text-white">
              {{ getStreamService.totalUnreadCount() }}
            </span>
            }
          </button>
          <div class="flex items-center justify-between rounded-lg px-3 py-2">
            <span class="text-sm font-medium text-primary">Notifications</span>
            <atom-notifications-drawer></atom-notifications-drawer>
          </div>
        </div>
        }

        <div class="my-4 border-t border-border"></div>

        @if (showFullNavigation() && canAccessSandboxBilling) {
        <div class="flex flex-col gap-2">
          <button type="button" (click)="openTopUpDrawer()"
            class="flex items-center justify-between rounded-lg bg-primary px-3 py-3 text-sm font-semibold text-white">
            <span>Wallet</span>
            <span>{{ walletService.availableBalance() | currency:walletService.currencyCode()?.toUpperCase() }}</span>
          </button>
          <button type="button" (click)="goToANonTab('/wallet-v2')"
            class="rounded-lg px-3 py-3 text-left text-sm font-medium text-primary hover:bg-zinc-100 dark:hover:bg-zinc-800">
            Wallet transactions
          </button>
          <button type="button" (click)="goToANonTab('/my-account')"
            class="rounded-lg px-3 py-3 text-left text-sm font-medium text-primary hover:bg-zinc-100 dark:hover:bg-zinc-800">
            My account
          </button>
          <div class="flex items-center justify-between rounded-lg px-3 py-2">
            <span class="text-sm font-medium text-primary">
              {{ themeService.isDarkMode() ? 'Dark mode' : 'Light mode' }}
            </span>
            <div
              class="group relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 inset-ring inset-ring-gray-900/5 outline-offset-2 outline-indigo-600 transition-colors duration-200 ease-in-out has-checked:bg-indigo-600 has-focus-visible:outline-2 dark:bg-white/5 dark:inset-ring-white/10 dark:outline-indigo-500 dark:has-checked:bg-indigo-500">
              <span
                class="size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-checked:translate-x-5">
              </span>
              <input type="checkbox" name="mobile-theme-toggle" [checked]="themeService.isDarkMode()"
                (change)="themeService.toggle()"
                class="absolute inset-0 size-full appearance-none focus:outline-hidden cursor-pointer"
                [attr.aria-label]="themeService.isDarkMode() ? 'Switch to light mode' : 'Switch to dark mode'" />
            </div>
          </div>
        </div>
        } @else {
        <div class="flex flex-col gap-2">
          <button type="button" (click)="goToANonTab('/my-account')"
            class="rounded-lg px-3 py-3 text-left text-sm font-medium text-primary hover:bg-zinc-100 dark:hover:bg-zinc-800">
            My account
          </button>
          @if (showFullNavigation()) {
          <div class="flex items-center justify-between rounded-lg px-3 py-2">
            <span class="text-sm font-medium text-primary">
              {{ themeService.isDarkMode() ? 'Dark mode' : 'Light mode' }}
            </span>
            <div
              class="group relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 inset-ring inset-ring-gray-900/5 outline-offset-2 outline-indigo-600 transition-colors duration-200 ease-in-out has-checked:bg-indigo-600 has-focus-visible:outline-2 dark:bg-white/5 dark:inset-ring-white/10 dark:outline-indigo-500 dark:has-checked:bg-indigo-500">
              <span
                class="size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-checked:translate-x-5">
              </span>
              <input type="checkbox" name="mobile-theme-toggle" [checked]="themeService.isDarkMode()"
                (change)="themeService.toggle()"
                class="absolute inset-0 size-full appearance-none focus:outline-hidden cursor-pointer"
                [attr.aria-label]="themeService.isDarkMode() ? 'Switch to light mode' : 'Switch to dark mode'" />
            </div>
          </div>
          }
        </div>
        }
      </nav>
    </div>
    }

    <div class="h-full w-full flex flex-row min-h-0 flex-1">
      <div
        class="flex min-h-0 flex-1 flex-col overflow-hidden"
        [class]="studioContentFrame() ? 'sm:py-2 lg:px-2' : ''">
        <div
          class="app-main-route-host flex min-h-0 flex-1 flex-col items-stretch justify-start overflow-y-auto scrollbar-transparent"
          [class]="studioContentFrame() ? 'rounded-t-lg border border-gray-200 p-4 dark:border-zinc-800 sm:rounded-lg' : 'p-0'"
          [ngClass]="mainRouteHostBackgroundClass()">
          <router-outlet />
        </div>
      </div>

      @if (aiGuideChatService.isAiGuideOpen()) {
      <div
        class="hidden lg:flex shrink-0 w-96 min-h-0 h-full flex-col overflow-hidden pb-2 pr-2">
        <!-- <om-border-beam class="h-full">
          <div class="container-wrapper h-[100%]">
            <h1 class="border-beam-title">
              Border Beam
            </h1>
          </div>
        </om-border-beam> -->

        <div class="h-full border border-gray-200 overflow-hidden rounded-lg dark:border-zinc-800">
          <app-ai-chat-sidebar />
        </div>
      </div>
      }
    </div>




    <div class="flex shrink-0 flex-col">
      @if (currentUserService.subscriptionActive() === false && canAccessSandboxBilling) {
      <div
        class="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 px-6 py-2.5 sm:px-3.5 sm:before:flex-1 dark:bg-gray-800/50 dark:after:pointer-events-none dark:after:absolute dark:after:inset-x-0 dark:after:bottom-0 dark:after:h-px dark:after:bg-white/10">
        <div aria-hidden="true"
          class="absolute top-1/2 left-[max(-7rem,calc(50%-52rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl">
          <div
            style="clip-path: polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)"
            class="aspect-577/310 w-144.25 bg-linear-to-r from-[#ff80b5] to-[#9089fc] opacity-30 dark:opacity-40"></div>
        </div>
        <div aria-hidden="true"
          class="absolute top-1/2 left-[max(45rem,calc(50%+8rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl">
          <div
            style="clip-path: polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)"
            class="aspect-577/310 w-144.25 bg-linear-to-r from-[#ff80b5] to-[#9089fc] opacity-30 dark:opacity-40"></div>
        </div>
        <div class="flex flex-wrap items-center gap-x-4 gap-y-2">
          <p class="text-sm/6 text-gray-900 dark:text-gray-100">
            <strong class="font-semibold">Choose a plan</strong><svg viewBox="0 0 2 2" aria-hidden="true"
              class="mx-2 inline size-0.5 fill-current">
              <circle r="1" cx="1" cy="1" />
            </svg>Upgrade your account to post briefs and hire creators.
          </p>
          <a (click)="startTrial()"
            class="flex-none rounded-full bg-gray-900 px-3.5 py-1 text-sm font-semibold text-white shadow-xs hover:bg-gray-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900 dark:bg-white/10 dark:inset-ring-white/20 dark:hover:bg-white/15 dark:focus-visible:outline-white cursor-pointer">Start
            Free <span aria-hidden="true">&rarr;</span></a>
        </div>
        <div class="flex flex-1 justify-end">

        </div>
      </div>
      } @else if (currentUserService.subscriptionActive() === true && currentUserService.currentSubscription() &&
      canAccessSandboxBilling &&
      currentUserService.currentSubscription()!.status == 'trialing' &&
      currentUserService.subscriptionHasPaymentMethod() === false) {
      <div
        class="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 px-6 py-2.5 sm:px-3.5 sm:before:flex-1 dark:bg-gray-800/50 dark:after:pointer-events-none dark:after:absolute dark:after:inset-x-0 dark:after:bottom-0 dark:after:h-px dark:after:bg-white/10">
        <div aria-hidden="true"
          class="absolute top-1/2 left-[max(-7rem,calc(50%-52rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl">
          <div
            style="clip-path: polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)"
            class="aspect-577/310 w-144.25 bg-linear-to-r from-[#ff80b5] to-[#9089fc] opacity-30 dark:opacity-40"></div>
        </div>
        <div aria-hidden="true"
          class="absolute top-1/2 left-[max(45rem,calc(50%+8rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl">
          <div
            style="clip-path: polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)"
            class="aspect-577/310 w-144.25 bg-linear-to-r from-[#ff80b5] to-[#9089fc] opacity-30 dark:opacity-40"></div>
        </div>
        <div class="flex flex-wrap items-center gap-x-4 gap-y-2">
          <p class="text-sm/6 text-gray-900 dark:text-gray-100">
            <strong class="font-semibold">{{ currentUserService.trialCountdownDaysLabel() }}</strong>
            <svg viewBox="0 0 2 2" aria-hidden="true" class="mx-2 inline size-0.5 fill-current">
              <circle r="1" cx="1" cy="1" />
            </svg>Add a payment method so you don't lose access. Cancel anytime.
          </p>
          <a (click)="addPaymentMethod()"
            class="flex-none rounded-full bg-gray-900 px-3.5 py-1 text-sm font-semibold text-white shadow-xs hover:bg-gray-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900 dark:bg-white/10 dark:inset-ring-white/20 dark:hover:bg-white/15 dark:focus-visible:outline-white cursor-pointer">Add
            payment method <span aria-hidden="true">&rarr;</span></a>
        </div>
        <div class="flex flex-1 justify-end">

        </div>
      </div>
      }

      @if (currentUserService.impersonationSession(); as session) {

      <div class="w-full">
        <div
          class="flex items-center gap-x-6 bg-amber-50 px-6 py-2.5 sm:px-3.5 sm:before:flex-1 dark:bg-amber-950/40 dark:after:pointer-events-none dark:after:absolute dark:after:inset-x-0 dark:after:top-0 dark:after:h-px dark:after:bg-white/10">
          <p class="text-sm/6 text-amber-900 dark:text-amber-100">
            <a>
              <strong class="font-semibold">{{ session.originalFirstName }}</strong><svg viewBox="0 0 2 2"
                aria-hidden="true" class="mx-2 inline size-0.5 fill-current">
                <circle r="1" cx="1" cy="1" />
              </svg> is impersonating {{ session.targetDisplayName }}&nbsp;
              <span aria-hidden="true">
                &rarr;
                
              </span>
            </a>
          </p>
          <div class="flex flex-1 justify-end">
            <button (click)="stopImpersonating()" type="button"
              class="-m-3 p-3 focus-visible:-outline-offset-4 inline-flex items-center gap-x-1.5 hover:cursor-pointer">
              <span class="">Stop Impersonating</span>
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="size-5 text-amber-900 dark:text-amber-100">
                <path
                  d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  } @else {
  <router-outlet class="h-full w-full" />
  }
</main>

@if (walletService.topUpDrawerOpen() && canAccessSandboxBilling) {
<wlt-top-up-drawer></wlt-top-up-drawer>
}

@if (choosePlanService.subscribeModalOpen() && canAccessSandboxBilling) {
<app-choose-plan></app-choose-plan>
}

@if (choosePlanService.addBoltOnModalOpen() && canAccessSandboxBilling) {
<app-choose-plan-bolt-on-add></app-choose-plan-bolt-on-add>
}

<atom-download-progress-toast />
<atom-refresh-results-toast />
<atom-brand-switch-transition />

@if (autoDeclineExplainer.isOpen()) {
  @if (autoDeclineExplainer.autoDeclineDays(); as autoDeclineDays) {
  <atom-auto-decline-explainer [days]="autoDeclineDays" (close)="autoDeclineExplainer.close()" />
  }
}

<!-- AI-Guided Walkthrough: guide overlay mounted app-wide so it can highlight elements on any page. --> 
@if (currentUserService.hasAnyRole([78])) {
<app-guide-overlay />
<app-guide-controls />
<app-launch-guide-button />
}

<!-- @if (choosePlanService.autoPilotModalOpen()) {
<app-choose-auto-pilot [briefId]="choosePlanService.autoPilotModalOpen() || ''"></app-choose-auto-pilot>
} -->